import { render, staticRenderFns } from "./LinkIntermediateCatchEvent.vue?vue&type=template&id=5d500317&scoped=true&"
import script from "./LinkIntermediateCatchEvent.vue?vue&type=script&lang=js&"
export * from "./LinkIntermediateCatchEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d500317",
  null
  
)

export default component.exports